import React, { useEffect, useState } from "react";
import { showAlertMessage } from "../components/MasterComponents/CommonFunctionalities";
import { validateForm } from "../components/UI Helpers/HelperFunctions/Helper";
import { useLocation, useNavigate } from "react-router-dom";
import CommonCalls from "../components/CommonAPICalls/CommonCalls";
import Settings from "../components/CommonAPICalls/Settings";
import FieldsRenderer from "../components/UI Helpers/InputFieldsRendererCommon/InputFieldsRendererComponent";
import Loader from "../components/UI Helpers/Simple Loading/Loader";

const apiCall = new CommonCalls();

const QurbaniDonationDetailPage = () => {
   const [saveBtn, setSaveBtn] = useState(false);
    const [loading, setLoading] = useState(true);
    const [formInputData, setFormInputData] = useState({});

    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const userid = params.get("userid");

    
    useEffect(() => {
        const getData = async () => {
            
            setLoading(true);
            if (userid) {
                const response = await apiCall.getQurbaniUserDetails(userid);
    
            if (response) {
                setFormInputData(response?.data);
            }
            setLoading(false);
            } else {
                showAlertMessage("Could not Find User", "fail");
                navigate("/portal");
            }
        }
        getData();
    }, [userid]);

    const inputsFielsAr = [
        {
            label: "Booking Amount Status",
            className: "col-lg-6",
            inputType: "dropdown",
            name: "donation_amount_status",
            id: "donation_amount_status",
            options:Settings?.enumTypesForStatus,
            // required: true,
            hideDefaultSelect:true
        },
  { id: 'first_name', name: 'first_name', label: 'First Name', inputType: 'text', disable: true },
  { id: 'last_name', name: 'last_name', label: 'Last Name', inputType: 'text', disable: true },
  { id: 'donation_amount', name: 'donation_amount', label: 'Booking Amount', inputType: 'text', disable: true }, 
  { id: 'donation_type', options: Settings.enumDonationType, name: 'donation_type', label: 'Book Type', inputType: 'dropdown', disable: true },
  { id: 'names_sacrifice_shares', name: 'names_sacrifice_shares', label: 'Qurbani Share Names', inputType: 'text', disable: true },
  { id: 'cnic_number', name: 'cnic_number', label: 'CNIC', inputType: 'text', disable: true },
  { id: 'phone_number', name: 'phone_number', label: 'Contact', inputType: 'text', disable: true },
  { id: 'email', name: 'email', label: 'Email', inputType: 'text', disable: true },
  { id: 'transaction_id', name: 'transaction_id', label: 'Transaction ID', inputType: 'text', disable: true },
//   { id: 'transaction_from_account_number', name: 'transaction_from_account_number', label: 'Account Number', inputType: 'text', disable: true },
//   { id: 'transaction_from_account_title', name: 'transaction_from_account_title', label: 'Acc. Title', inputType: 'text', disable: true },
  { id: 'total_portions', name: 'total_portions', label: 'Total Portions', inputType: 'text', disable: true }
    ];

    const updateUserData = async () => {
        setSaveBtn(true);
        let validationResponse = validateForm(inputsFielsAr, formInputData);
        if (!validationResponse) {
            setSaveBtn(false);
            return;
        }
        const response = await apiCall.putQurbaniUser(userid, formInputData);
        if (response?.status === 202) {
            setSaveBtn(false);
            showAlertMessage(response?.message, "success");
            return response;
        } else {
            setSaveBtn(false);
            showAlertMessage(response?.message, "fail");
            return;
        }
    };

    return (
        <>
             <div className="user-detail-view-container container-fluid ps-4 pe-4 py-4">
               
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            setSaveBtn(true);
                            updateUserData();
                        }}
                    >
                        <div className="w-100 text-end ">
                            <button
                                type="submit"
                                className="connect-button w-fit p-3 py-2"
                                disabled={saveBtn}
                            >
                                <div>
                                    <span> Save </span>{" "}
                                    {saveBtn ? (
                                        <output
                                            className="spinner-border spinner-border-sm ms-1"
                                            aria-hidden="true"
                                        ></output>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </button>
                        </div>

                        {loading ? <Loader /> : (
                            <FieldsRenderer
                                fieldsArray={inputsFielsAr}
                                updateState={setFormInputData}
                                currentState={formInputData}
                            />
                        )}
                    </form>
                </div>
        </>
    );
};

export default QurbaniDonationDetailPage;